import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

export const SnackBarDisplayTime = 5000;
export const SnackBarHorizontalPosition: MatSnackBarHorizontalPosition = 'center';
export const SnackBarVerticalPosition: MatSnackBarVerticalPosition = 'bottom';
export const SnackBarPanelClass: string[] = ['kws__snackbar'];